/**
 * @module app.bdc.list.formCashDrawerInfoCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function FormCashDrawerInfoCtrl($scope, $uibModalInstance, cashDrawer) {
        var self = {};
        self.cashDrawer = cashDrawer;

        self.close = function() {
            $uibModalInstance.dismiss('cancel');
        };

        return self;
    }

    FormCashDrawerInfoCtrl.$inject = ['$scope', '$uibModalInstance', 'cashDrawer'];

    angular
        .module('app.bdc.list.formCashDrawerInfoCtrl', ['ui.bootstrap.modal'])
        .controller('FormCashDrawerInfoCtrl', FormCashDrawerInfoCtrl);
});
